module.exports = __webpack_public_path__ + "assets/img/car24.b1db5c0b.jpg";